(function () {
    'use strict';

    var core = angular.module('app.core');

    var config = {
        appErrorPrefix: '[obtAdvisor Error] ',
        appTitle: 'TherapistBooking',
        calendarDisabledImage:'image/calendarDisabledImage.png',
        appServiceBaseUrl: '.',
        language:'fr',
        ui:'21'
    };
    core.value('config', config);

    core.config(toastrConfig);
    toastrConfig.$inject = ['toastr'];
    /* @ngInject */
    function toastrConfig(toastr) {
        toastr.options.timeOut = 4000;
        toastr.options.positionClass = 'toast-bottom-right';
    }

    core.config(reCAPTCHA);
    reCAPTCHA.$inject = ['reCAPTCHAProvider'];
    function reCAPTCHA(reCAPTCHAProvider) {
        // required: please use your own key :)
        reCAPTCHAProvider.setPublicKey('6Lexr_USAAAAADBE6Z3osj77aI8VH1AR_zeZPRHe');

        // optional: gets passed into the Recaptcha.create call
        reCAPTCHAProvider.setOptions({
            theme:"custom",
            custom_theme_widget:"recaptcha_widget"
        });
    }
    core.config(function(vcRecaptchaServiceProvider){
  vcRecaptchaServiceProvider.setDefaults({
    key: '6LflOkIUAAAAAHywKymkFP3qML2h5Z0TH5axVJ8S'

  });
});
    core.config(mapConfig);
    mapConfig.$inject = ['uiGmapGoogleMapApiProvider'];
    /* @ngInject */
    function mapConfig (uiGmapGoogleMapApiProvider) {
        uiGmapGoogleMapApiProvider.configure({
//            key: 'AIzaSyC1M07ycLC7xzr9_f5iN-f1DkLIS6kiajc',
            key: 'AIzaSyBAZj6rZNYvt6O7EsTipxGrl8_xSUmaTZI',  ///maleye key
            v: '3',
            libraries: 'weather,geometry,visualization'
        });
    }


    core.config(translateConfig);
    /*@ngInject*/
    function translateConfig($translateProvider) {
        $translateProvider.preferredLanguage('fr');
        $translateProvider.useStaticFilesLoader({
            prefix: './locales/',
            suffix: '.json'
        })
    }

    core.config(configure);
    configure.$inject = ['$logProvider', 'routerHelperProvider', 'exceptionHandlerProvider'];
    function configure($logProvider, routerHelperProvider, exceptionHandlerProvider) {
        if ($logProvider.debugEnabled) {
            $logProvider.debugEnabled(true);
        }
        exceptionHandlerProvider.configure(config.appErrorPrefix);
        routerHelperProvider.configure({docTitle: config.appTitle });
    }

    core.run(['$templateCache', function($templateCache) {
        //ADD THE TEMPLATE INSIDE THE $TEMPLATECACHE
        $templateCache.put("lightbox.html",  require("html!./../widgets/lightbox.html"));
        // NG INCLUDE
        $templateCache.put("app/layout/header/header-advisor.html",  require("html!./../layout/header/header-advisor.html"));
        $templateCache.put("app/layout/subFooter.html",  require("html!./../layout/subFooter.html"));
        $templateCache.put("app/layout/header/header-association.html",  require("html!./../layout/header/header-association.html"));
        $templateCache.put("app/booking/booking-cascade-options.html",  require("html!./../booking/booking-cascade-options.html"));
        $templateCache.put("app/layout/header/header-clinic.html",  require("html!./../layout/header/header-clinic.html"));
        $templateCache.put("app/layout/header/header-clinicTherapist.html",  require("html!./../layout/header/header-clinicTherapist.html"));
        $templateCache.put("app/layout/header/header-404.html",  require("html!./../layout/header/header-404.html"));
        $templateCache.put("app/layout/header/header-dynamic.html",  require("html!./../layout/header/header-dynamic.html"));
        $templateCache.put("app/layout/sidebar.html",  require("html!./../layout/sidebar.html"));
        $templateCache.put("app/layout/header.html",  require("html!./../layout/header.html"));
        $templateCache.put("app/layoutV2/sidebar.html",  require("html!./../layoutV2/sidebar.html"));
        $templateCache.put("app/layout/footer.html",  require("html!./../layout/footer.html"));
        $templateCache.put("app/layoutV2/header.html",  require("html!./../layoutV2/header.html"));
        $templateCache.put("app/layoutV2/content.html",  require("html!./../layoutV2/content.html"));
        $templateCache.put("app/layoutV2/footer.html",  require("html!./../layoutV2/footer.html"));
        $templateCache.put("app/layout/header/header-therapist.html",  require("html!./../layout/header/header-therapist.html"));

        // TEMPLATE-URL
        $templateCache.put("app/booking/add.html",  require("html!./../booking/add.html"));
        $templateCache.put("app/login/signIn.html",  require("html!./../login/signIn.html"));
        $templateCache.put("app/therapist/filter-tpl.html",  require("html!./../therapist/filter-tpl.html"));
        $templateCache.put("app/booking/requestBooking.html",  require("html!./../booking/requestBooking.html"));
        $templateCache.put("app/booking/addToWaitingList.html",  require("html!./../booking/addToWaitingList.html"));
        $templateCache.put("app/resellers/reports/resellerBookingReport.filter.html",  require("html!./../resellers/reports/resellerBookingReport.filter.html"));
        $templateCache.put("app/booking/buttonRequestBooking.html",  require("html!./../booking/buttonRequestBooking.html"));

        $templateCache.put("app/blocks/modal/obt-modalWrapper.directive.html",  require("html!./../blocks/modal/obt-modalWrapper.directive.html"));

        $templateCache.put("app/widgets/profileCard/obt-ProfileCard.html",  require("html!./../widgets/profileCard/obt-ProfileCard.html"));
        $templateCache.put("app/widgets/profileCard/obt-ProfileCard-map.html",  require("html!./../widgets/profileCard/obt-ProfileCard-map.html"));

        $templateCache.put("app/widgets/map/obt-map-window.tpl.html",  require("html!./../widgets/map/obt-map-window.tpl.html"));

        $templateCache.put("app/widgets/obtSection/obtSection.html",  require("html!./../widgets/obtSection/obtSection.html"));
        $templateCache.put("app/widgets/obtSection/type_1.html",  require("html!./../widgets/obtSection/type_1.html"));
        $templateCache.put("app/widgets/obtSection/type_2.html",  require("html!./../widgets/obtSection/type_2.html"));
        $templateCache.put("app/widgets/obtSection/type_3.html",  require("html!./../widgets/obtSection/type_3.html"));
        $templateCache.put("app/widgets/obtSection/type_4.html",  require("html!./../widgets/obtSection/type_4.html"));
        $templateCache.put("app/widgets/obtSection/type_5.html",  require("html!./../widgets/obtSection/type_5.html"));
        $templateCache.put("app/widgets/obtSection/type_6.html",  require("html!./../widgets/obtSection/type_6.html"));
        $templateCache.put("app/widgets/obtSection/type_7.html",  require("html!./../widgets/obtSection/type_7.html"));
        $templateCache.put("app/widgets/obtSection/type_8.html",  require("html!./../widgets/obtSection/type_8.html"));
        $templateCache.put("app/widgets/obtSection/type_9.html",  require("html!./../widgets/obtSection/type_9.html"));
        $templateCache.put("app/widgets/obtSection/type_100.html",  require("html!./../widgets/obtSection/type_100.html"));
        $templateCache.put("app/widgets/obtSection/type_101.html",  require("html!./../widgets/obtSection/type_101.html"));
        $templateCache.put("app/widgets/obtSection/type_103.html",  require("html!./../widgets/obtSection/type_103.html"));
        $templateCache.put("app/widgets/obtSection/type_106.html",  require("html!./../widgets/obtSection/type_106.html"));
        $templateCache.put("app/widgets/obtMenu.html",  require("html!./../widgets/obtMenu.html"));

        $templateCache.put("template/ngCart/addtocart.html",  require("html!./../widgets/cart/addtocart.html"));
        $templateCache.put("template/ngCart/checkout.html",  require("html!./../widgets/cart/checkout.html"));
        $templateCache.put("template/ngCart/cart.html",  require("html!./../widgets/cart/cart.html"));
        $templateCache.put("template/ngCart/summary.html",  require("html!./../widgets/cart/summary.html"));

        // templateUrl



          $templateCache.put("app/login/updateSectionDirective/updateSectionDirective.html",  require("html!./../login/updateSectionDirective/updateSectionDirective.html"));

    }]);

    core.run(['$anchorScroll', function($anchorScroll) {
        $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
    }]);

    core.run(function($window, $rootScope, RouterTransitionService, $translate, config, $anchorScroll,dataservice,$state){
        //$window.moment.locale('en-my-settings', {
        //    // customizations.
        //    'longDateFormat' : {'lly': "ddd, MMMM D"}
        //});

        // debug - ui router //
        $rootScope.$on('$stateChangeStart',function(event, toState, toParams, fromState, fromParams){
            //if(toParams.language != fromState.language){
            //  console.debug('UPDATE LANGUAGE from ', fromState.language, ' to ', toParams.language);
            //  $translate.use(toParams.language); //update the selected labguage if required
            //  config.language = toParams.language;
            //}
            RouterTransitionService.stateChangeStart(toState, toParams, fromState, fromParams);
           // console.log('$stateChangeStart to '+toState.name+'- fired when the transition begins. toState,toParams : \n',toState, JSON.stringify(toParams));

        });

        $rootScope.$on('$stateChangeError',function(event, toState, toParams, fromState, fromParams){
            RouterTransitionService.stateChangeError(toState, toParams, fromState, fromParams);
            console.log('$stateChangeError - fired when an error occurs during transition.');
            console.log(arguments);
        });

        $rootScope.$on('$stateChangeSuccess',function(event, toState, toParams, fromState, fromParams){
            RouterTransitionService.stateChangeSuccess(toState, toParams, fromState, fromParams);
            console.log('$stateChangeSuccess to '+toState.name+'- fired once the state transition is complete.');
            if(!$state.includes('therapistClinic.service')){
                    dataservice.therapist.getTherapist(toParams.cId, toParams.tId).then(function(data){
                      console.log(data,'not service');
                    dataservice.page.setNavBarTitle(data.navBarTitle);
                    dataservice.page.setMenu(data.navBarMenu);
                    dataservice.page.setPageSection(data.pageSections);
                 });
            }
            else{
              dataservice.dynamic.getServiceContent(toParams.sId, toParams.cId).then(function(data){
                console.log(data,'my params');
              dataservice.page.setPageSection(data.features);
              });
        
            }
            $anchorScroll();
        });

        $rootScope.$on('$viewContentLoaded',function(event){
            RouterTransitionService.viewContentLoaded();
            console.log('$viewContentLoaded - fired after dom rendered',event);
        });

        $rootScope.$on('$stateNotFound',function(event, unfoundState, fromState, fromParams){
            RouterTransitionService.stateNotFound(unfoundState, fromState, fromParams);
            console.log('$stateNotFound '+unfoundState.to+'  - fired when a state cannot be found by its name.');
            console.log(unfoundState, fromState, fromParams);
        });
    });
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/core/config.js
 ** module id = 103
 ** module chunks = 0
 **/